import { create } from 'zustand'

import { getPreviaSemanal, liberarPreviaSemanal, submitPreviaSemanal } from './provider'

import type { UseConsolidatedEntryProps } from './types'

export const useConsolidatedEntry = create<UseConsolidatedEntryProps>((set) => ({
  consolidatedData: null,
  setConsolidatedData: (value) => set({ consolidatedData: value }),

  isConsolidatedDataLoading: false,
  setIsConsolidatedDataLoading: (value) => set({ isConsolidatedDataLoading: value }),

  isSubmitLoading: false,
  setIsSubmitLoading: (value) => set({ isSubmitLoading: value }),

  isLiberarPreviaSemanalLoading: false,
  setIsLiberarPreviaSemanalLoading: (value) => set({ isLiberarPreviaSemanalLoading: value }),

  getPreviaSemanal,
  submitPreviaSemanal,
  liberarPreviaSemanal
}))
